import React from 'react'

const React_Coding_Practice_37 = () => {
  return (
    <div>
      <h1>Coding Pratice 37</h1>
    </div>
  )
}

export default React_Coding_Practice_37
